import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styles from "./CurrencyInput.module.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo, faXmark } from '@fortawesome/free-solid-svg-icons';

const CurrencyInput = ({ onChange, resetFlag }) => {
  const { t } = useTranslation();
  const [val, setVal] = useState("");
  const [error, setError] = useState(""); // エラーメッセージ用の状態

  useEffect(() => {
    setVal("");
  }, [resetFlag]);

  const handleInputChange = (e) => {
    const inputValue = e.target.value;

    if (!/^\d*$/.test(inputValue)) {
      // 半角数字以外が含まれていた場合、エラーメッセージをセット
      setError(t('半角数字で入力してください'));
    } else {
      // 入力値が半角数字の場合、エラーメッセージをクリアし、状態を更新
      setError("");
      setVal(inputValue);
      onChange(inputValue);
    }
  };

  const handleReset = () => {
    setVal("");
    onChange("");
  };

  return (
    <div className={styles.currencyInputWrapper}>
      <input
        type="text"
        value={val}
        autoComplete="off"
        autocomplete="off"
        onChange={handleInputChange}
        className={styles.currencyInput}
      />
      <span className={styles.mark}>{t("円")}</span>
      {val && (
        <button className={styles.resetButton} onClick={handleReset}>
          <FontAwesomeIcon icon={faXmark} />
        </button>
      )}
      {/* エラーメッセージがある場合は表示 */}
      {error && <div className={styles.errorMessage}><span className={styles.alertIcon}><FontAwesomeIcon icon={faCircleInfo} /></span> {error}</div>}
    </div>
  );
};

export default CurrencyInput;
